import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { computed, onMounted, ref } from "vue";
import { withPrefix } from "@/utils/redirect";
import { isEmpty } from "@/utils/utils";
import WorkflowTree from "./WorkflowTree.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import ToolLinkPopover from "@/components/Tool/ToolLinkPopover.vue";
import WorkflowStepIcon from "@/components/WorkflowInvocationState/WorkflowStepIcon.vue";
import WorkflowStepTitle from "@/components/WorkflowInvocationState/WorkflowStepTitle.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowDisplay',
    props: {
        workflowId: null,
        workflowVersion: { default: null },
        embedded: { type: Boolean, default: false },
        expanded: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const errorContent = ref();
        const itemContent = ref(null);
        const loading = ref(true);
        const workflowName = computed(() => (itemContent.value ? itemContent.value.name : "..."));
        const downloadUrl = computed(() => withPrefix(`/api/workflows/${props.workflowId}/download?format=json-download`));
        const importUrl = computed(() => withPrefix(`/workflow/imp?id=${props.workflowId}`));
        const itemUrl = computed(() => {
            let extra = "";
            if (props.workflowVersion) {
                extra = `&version=${props.workflowVersion}`;
            }
            return withPrefix(`/api/workflows/${props.workflowId}/download?style=preview${extra}`);
        });
        onMounted(async () => {
            axios
                .get(itemUrl.value)
                .then((response) => {
                itemContent.value = response.data;
                loading.value = false;
            })
                .catch((error) => {
                errorContent.value = error.response.data.err_msg;
                loading.value = false;
            });
        });
        return { __sfc: true, props, errorContent, itemContent, loading, workflowName, downloadUrl, importUrl, itemUrl, isEmpty, WorkflowTree, LoadingSpan, ToolLinkPopover, WorkflowStepIcon, WorkflowStepTitle };
    }
});
